import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { UserService } from 'src/app/services/infra/user/user.service';
import { VersionService } from 'src/app/services/infra/version/version.service';

@Component({
  selector: 'app-user',
  templateUrl: './user.component.html',
  styleUrls: ['./user.component.scss'],
})
export class UserComponent {
  public version: string;

  constructor(
    public userService: UserService,
    private readonly _router: Router,
    private readonly _versionService: VersionService
  ) {
    this.version = this._versionService.version;
  }

  public logout(): void {
    this.userService.logout();
    this._router.navigateByUrl('/login');
  }
}
